import './application-settings.css';

import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import { closeOutline, openOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useGetScratchpadBucketQuery } from '../../../../../api/graphql/generated';
import { useHasFeature } from '../../../../../api/hooks/feature.hooks';
import { useScratchpadServiceContext } from '../../../../../components/machine/scratchpad/scratchpad-service-context-provider';
import { FieldLocked } from '../../../../../components/ui/field-locked';
import { getLocalizedText } from '../../../../../i18n/i18n.utils';
import { useIsMachineActive } from '../../../../../pages/machine/machine-context-provider';

interface ApplicationSettingsBucketPickerProps {
  onOpenSearch: () => void;
  onUnlinkSet?: () => void;
}

const ApplicationSettingsBucketPicker = (
  props: ApplicationSettingsBucketPickerProps
): ReactElement => {
  const { onOpenSearch, onUnlinkSet } = props;
  const isMachineActive = useIsMachineActive();
  const { scratchpad } = useScratchpadServiceContext();
  const { data: scratchpadBucketData } = useGetScratchpadBucketQuery({
    variables: {
      input: {
        id: String(scratchpad.bucket1Id),
      },
    },
    skip: !scratchpad.bucket1Id,
  });
  const bucketName = scratchpadBucketData?.getScratchpadBucket.name;
  const hasUnlinkFeature = useHasFeature<boolean | undefined>(
    'show-cobot-welder-disassociate-bucket'
  );

  const isDisabled = !isMachineActive;

  // TODO: need to figure out what to do about widget styles when not in form
  return (
    <IonItem
      lines="full"
      className="transparent-background widget parameter-selected"
      href=""
      disabled={isDisabled}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onClick={(e: any) => {
        e.preventDefault();
        onOpenSearch();
      }}
      detail={false}
    >
      <IonLabel color={bucketName ? undefined : 'medium'}>
        <span>
          {bucketName ?? getLocalizedText('common:select_from_library')}
        </span>
      </IonLabel>
      {!isDisabled && (
        <IonIcon slot="end" icon={openOutline} color={'medium'} />
      )}
      <FieldLocked show={isDisabled} />
      {hasUnlinkFeature && (
        <IonIcon
          slot="end"
          icon={closeOutline}
          color={'medium'}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (typeof onUnlinkSet === 'function') {
              onUnlinkSet();
            }
          }}
        />
      )}
    </IonItem>
  );
};

export { ApplicationSettingsBucketPicker };
